<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印电阻箱产品标"
      class="materialCodeModal"
      width="500px"
      top="5vh">
    <!--    80*40-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="140px">
        <el-form-item label="产品名称">
          <el-input v-model="printName"/>
        </el-form-item>
        <el-form-item label="LOGO">
          <el-checkbox v-model="logoVisible"/>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="printQty"/>
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input v-model="printType"/>
        </el-form-item>
        <el-form-item label="DATE">
          <el-input v-model="printDate"/>
        </el-form-item>
        <el-form-item label="条码">
          <el-input v-model="barCodeText">
            <el-button type="primary" slot="append" @click="codeChange">重新生成</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-divider/>
    <div id="labelContent3">
      <div v-for="(productInfo,index) in productInfos" :key="index" id="printMaterialBoxLabel3">
        <div style="display: flex;" v-if="logoVisible">
          <img style="width: 100px;height: 20px;"  :src="logoSrc">
          <div style="margin-left: 90px;font-size: 12px;font-weight: bold;margin-top: 3px;">www.howcore.com</div>
        </div>

        <div style="margin:0 5px;text-align: center;">
          <div style="display: flex;text-align: center;">
            <div style="font-size: 15px;font-weight: bold;">产品名称：</div>
            <div style="font-size: 15px;font-weight: bold;">{{printName}}</div>
          </div>
          <div style="display: flex;text-align: center;">
            <div  style="font-size: 15px;font-weight: bold;">规格型号：</div>
            <div style="font-size: 16px;font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;">{{printType}}</div>
          </div>
          <div style="display: flex;text-align: center;">
            <div style="font-size: 15px;font-weight: bold;">生产日期：</div>
            <div style="font-size: 15px;font-weight: bold;">{{printDate}}</div>
          </div>
          <div style="height: 25px;text-align: center;">
            <img style="width:100%;height: 25px;" :id="(() => 'barCode3_'+productInfo.pkid)()">
          </div>
          <div style="font-size: 14px;font-weight: bold;">{{productInfo.text}}</div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        logoVisible: true,
        printType: "",
        printQty: "",
        printDate: "",
        printName: "",
        productInfo: {},
        productInfos: [],
        logoSrc: "",
        barCodeText: "",
        printOption: {
          id: "labelContent3",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        this.logoSrc = "../../../../img/se/print_logo.png";
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.printQty=productInfo.quantity;
        this.printType = this.productInfo.specification;
        this.printName = this.productInfo.materialName;
        this.printDate = this.productInfo.planStartTime;
        this.barCodeText = moment(new Date(this.printDate)).format("YYMMDD") + this.productInfo.productionOrderNo.substring(this.productInfo.productionOrderNo.length - 4) + "001";

        this.productInfos = [];
        this.setBarcode(1);
        // this.$nextTick(() => {
        //   document.getElementById("barCode3_" + this.productInfo.pkid).innerHTML = "";
        //   this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });
      },

      setBarcode(baseNum) {
        this.productInfos=[];
        for (var i = 0; i < this.printQty; i++) {
          // let text = moment(new Date(this.printDate)).format("YYMMDD")
          let text = this.barCodeText.substring(0, 6)
              + this.productInfo.productionOrderNo.substring(this.productInfo.productionOrderNo.length - 4)
              + (parseInt(baseNum) + i).toString().padStart(3, "0");
          let info = {
            pkid: text,
            text: text,
          };
          this.productInfos.push(info);
          this.$nextTick(() => {
            document.getElementById("barCode3_" + text).innerHTML = "";
            this.bindBarCode(text, text);
          });
        }
      },

      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode3_" + id), row, {
          text: text,
          // fontSize: 18,
          width: 4,
          height: 22,
          margin: 0,
          displayValue: false,
          // fontOptions: "bold",
        });
      },
      codeChange() {
        this.productInfos = [];
        // this.$nextTick(() => {
        // document.getElementById("barCode3_" + this.productInfo.pkid).innerHTML = "";
        // this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });

        let t = this.barCodeText.substring(this.barCodeText.length - 3, this.barCodeText.length);
        this.setBarcode(t);
      },

      print() {
        // this.printLoading = true;
        // document.body.innerHTML = document.getElementById("printMaterialBoxLabel").parentNode.innerHTML;
        // window.print();
        // window.location.reload();
        //
      },
    },
  };
</script>
<style lang="scss" scoped>
//.materialCodeModal .el-dialog__header {
//  position: fixed;
//  width: 100%;
//  top: 0;
//  z-index: 99999;
//  box-sizing: border-box;
//}
//
//.materialCodeModal .el-dialog__footer {
//  position: fixed;
//  width: 100%;
//  bottom: 0;
//  z-index: 99999;
//  box-sizing: border-box;
//  background-color: #fff;
//}
//
//.materialCodeModal .el-dialog {
//  margin: 2% auto !important;
//  transform: scale3d(1, 1, 1);
//  padding-top: 30px;
//  padding-bottom: 39px;
//  height: 90%;
//}
//
//.materialCodeModal .el-divider--horizontal {
//  margin: 10px 0;
//}
//
//.materialCodeModal .el-dialog .el-dialog__body {
//  height: 100%;
//  background-color: #fff;
//  overflow: scroll;
//}
</style>

<style lang="scss" scoped>
#printMaterialBoxLabel3 {
  width: 80mm;
  height: 40mm;
  margin: 0 auto;
  //margin-top: 1.5mm;
  page-break-before: always;
  //font-size: 10px;
  align-items: center;

}
</style>
